import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren, ViewEncapsulation,  } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckBoxComponent } from '@syncfusion/ej2-angular-buttons';
import { DropDownListComponent, MultiSelectComponent } from '@syncfusion/ej2-angular-dropdowns';
import { GridComponent, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { DialogComponent, TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { CheckBox } from '@syncfusion/ej2-buttons';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import { fadeInOut } from '../../shared/helpers/animations';
import { selectCompanyTypeValidator } from '../../shared/helpers/company-type.validator';
import { IContactCompany } from '../../shared/models/contact-company-association.model';
import { IBusinessOperationQualifier, IBusinessOperationQualifierList, ICompany, ICompanyDetail, ICompanyTypeInfo, IContactDetail, IContactForSave, IEntity, ILLBusinessCategory, INdcLabeler } from '../../shared/models/index';
import { NonLatestCompanyContact } from '../../shared/models/non-latest-company-contact';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { AuthorizationService, CompanyContactService } from '../../shared/services/index';
import { RefdataService } from '../../shared/services/refdata.service';
import { StorageManagerService } from '../../shared/services/storage-manager.service';
import { Utilities } from '../../shared/services/utilities';
import { ContactDetailComponent, ERFormComponent, LCRFormComponent, LLFormEstablishmentComponent, LLFormLabelerComponent, LLFormRegistrantComponent } from '../index';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-company-details',
    templateUrl: './company-details.component.html',
    styleUrls: ['./company-details.component.scss'],
    animations: [fadeInOut],
    encapsulation: ViewEncapsulation.Emulated
})
export class CompanyDetailsComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
    public toolTipControl: TooltipComponent;
    public companyForm: UntypedFormGroup;
    public businessOperations: UntypedFormArray;
    public pageTitle: string;
    public companies: Object;
    private sub: Subscription;

    // Use with the generic validation message class
    displayMessage: { [key: string]: string } = {};
    errorMessage: string;
    @ViewChild('establishment') public establishment: CheckBoxComponent;
    @Input() companyHistory_grid_data: ICompanyDetail[];
    @Input() company_grid_data: ICompanyDetail[];
    @Input() contactData: IContactDetail[];
    @ViewChild('ejDialog') public ejDialog: DialogComponent;
    @ViewChild('dialogConfirmation') public dialogConfirmation: DialogComponent;
    @ViewChildren('BusinessOperQ') boq_mdrp: QueryList<MultiSelectComponent>;
    @ViewChild('contactDetail') contact: ContactDetailComponent;

  @ViewChild('countryRegionDdw') countryRegionDdw: DropDownListComponent;

  @ViewChild('tooltipCompanies') tooltipCompanies: TooltipComponent;

  @ViewChild('tooltipError') tooltipError: TooltipComponent;

  @ViewChild('companyHistory_grid') companyHistoryGrid: GridComponent;

  @ViewChild('errorGrid') errorGrid: GridComponent;

    msArray: MultiSelectComponent[] = [];
    companyData: any;
    public initialPage: Object;
    public sortOptions: Object;
    countries: IEntity[];
    regions$: Observable<any>;
    regions: IEntity[];
    businessCategories: ILLBusinessCategory[];
    businessOperationsQualifierList: IBusinessOperationQualifier[][] = [];
    selectedBusinessCategoryId: any;
    selectedCountryId: string;
    selectedRegionId: string;
    selectedDrpRegionId: string;
    buttonText: string;
    contactId: string;
    submitted = false;
    loading = false;
    disableUpdateCompanyButton = true;
    company: ICompanyDetail;
    companyId: string;
    companyRevisionId: string;
    contactRevisionId: string;
    version: string;
    formStatus: string;
    COUNTRY_USA = '185'; // Country code for United States
    countryRegion: any;
    country: any;
    countryId: any;
    companyForCreation: ICompany;
    lstCompanyAssociations: IContactForSave[] = [];
    lstBusiOperQualifiers: IBusinessOperationQualifier[] = [];
    companyAssociations: IContactCompany[] = [];
    contactValidationTitleMsg: string;
    animationSettings: Object = { effect: 'Zoom' };
    hide: any;
    public visible: Boolean = true;
    public hidden: Boolean = false;
    public confirmCloseIcon: Boolean = true;
    public showCloseIcon: Boolean = true;
    contacts: IEntity[];
    selectedContact: string;
    public selectedContact_est: string;
    selectedContact_3rdParty_est: string;
    selectedContactId_Importer: string;
    selectedContactId_Labeler: string;
    selectedContactId_Registrant: string;
    selectedContactId_usAgent: string;
    regionFromDrp: string;
    public companyType: string;
    showEditLink_Est = false;
    showEditLink_3rdParty_Est = false;
    showEditLink_Importer = false;
    showEditLink_Labeler = false;
    showEditLink_USAgent = false;
    showEditLink_Registrant = false;
    isEstablishmentChecked = false;
    is3rdPartyEstablishmentChecked = false;
    bIsDraftMode: boolean;
    bHasPermission = false;
    bHasDeletePermission = false;
    public businessOperationsPlaceholder: String = 'Select option(s)';
    public animationSettings_dialog: Object = { effect: 'Fade' };
    businessOperationArray: IBusinessOperationQualifier[] = [];
    labelers: INdcLabeler[] = [];
    boArr: number[] = [];
    iconTypeContact = false;
    splValidationMessages: any[];
    bValidationErrorExist = false;
    bIsInternationalCompany = false;
    public clipmodecolumn = { class: 'e-tooltipcolumn' };

    @Output() cancelButtonClickedOutput = new EventEmitter<any>();
    @Output() companyOutput = new EventEmitter<any>();
    @Input() parentComponentInput: LCRFormComponent | ERFormComponent | LLFormLabelerComponent | LLFormEstablishmentComponent | LLFormRegistrantComponent;

    // Business Operations
    businessOperationsTermList: IBusinessOperationQualifier[];
    nonLatestCompanyContact = new NonLatestCompanyContact();

    // maps the appropriate column to fields property
    public companyTypes: ICompanyTypeInfo[] = [{
        type: 'Establishment_Owned',
        ckName: 'isEstablishmentOwner',
        dbField: 'establishmentOwner',
        dropdownCtrlName: 'contact_Est'
    },
    {
        type: 'Establishment_Third_Party',
        ckName: 'isThirdPartyEstablishment',
        dbField: 'isThirdPartyEstablishment',
        dropdownCtrlName: 'contact_3rdParty_Est'
    },
    {
        type: 'Importer',
        ckName: 'isImporter',
        dbField: 'importer',
        dropdownCtrlName: 'contact_Importer'
    },
    {
        type: 'Labeler',
        ckName: 'isLabeler',
        dbField: 'labeler',
        dropdownCtrlName: 'contact_Labeler'
    },
    {
        type: 'Registrant',
        ckName: 'isRegistrant',
        dbField: 'registrant',
        dropdownCtrlName: 'contact_Registrant'
    },
    {
        type: 'US_Agent',
        ckName: 'isUSAgent',
        dbField: 'usAgent',
        dropdownCtrlName: 'contact_usAgent'
    }
    ];

    public companyTypeCtrlNames: string[] = ['isEstablishmentOwner', 'isThirdPartyEstablishment', 'isImporter', 'isLabeler', 'isRegistrant', 'isUSAgent'];
    // maps the appropriate column to fields property
    public businessCategoryFields: Object = {
        text: 'label',
        value: 'categoryId'
    };
    public businessOperationFields: Object = {
        text: 'parentTermValueName',
        value: 'parentTermValueCode'
    };
    public businessOperationsQualifierField: Object = {
        text: 'childTermValueName',
        value: 'childTermValueCode'
    };
    public countryFields: Object = {
        text: 'label',
        value: 'id'
    };
    public stateFields: Object = {
        text: 'regionAndAbbreviation',
        value: 'regionAndAbbreviation'
    };
    public contactFields: Object = {
        text: 'contactName',
        value: 'contactRevisionId'
    };

    // set the placeholder to DropDownList input elements
    public businessCategoryWaterMark = 'Select a business category';
    public businessOperationWaterMark = 'Select a business operation';
    public businessOperationQualifierWaterMark = 'Select a business operation Qualifier';
    public stateWaterMark = 'Select a state/province';
    public countryWaterMark = 'Select a country';
    public contactWaterMark = 'Select a contact';
    formErrors = {
        address: '',
        city: '',
        countryId: '',
        countryRegion: '',
        zip: '',
        companyName: '',
        businessCategoryId: '',
        status: '',
        duns: '',
        fei: '',
        businessOperations: '',
        isLabeler: '',
        isRegistrant: '',
        isUSAgent: '',
        isImporter: '',
        isEstablishmentOwner: '',
        isThirdPartyEstablishment: '',
        labelerCodes: '',
        contactEst: '',
        contact3rdPartyEst: '',
        contactImporter: '',
        contactLabeler: '',
        contactRegistrant: ''
    };

    validationMessages = {
        companyName: {
            required: 'Company name is required.'
        },
        city: {
            required: 'City is required.'
        },
        address: {
            required: 'Street address is required.'
        },
        countryId: {
            required: 'Country is required.'
        },
        countryRegion: {
            required: 'State/Province is required'
        },
        zip: {
            required: 'Postal code is required',
            pattern: 'Invalid postal code'
        },
        duns: {
            pattern: 'Cannot contain special characters',
            minlength: 'Must be 9 digits',
            required: 'DUNS number is required'
        },
        businessCategoryId: {
            required: 'Business category is required'
        },
        businessOperations: {
            required: 'business Operations is required.'
        },
        status: {
            required: 'Status is required'
        }
    };

    constructor(
        private fb: UntypedFormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router, private cdRef: ChangeDetectorRef,
        private authService: AuthenticationService,
        private authorizationService: AuthorizationService,
        private toastr: ToastrService, private storageManagerService: StorageManagerService,
        private companyService: CompanyContactService,
        private utilService: Utilities,
        private refDataService: RefdataService, private sanitizer: DomSanitizer) { }

    // set the height of the popup element
    public ddwHeight = '220px';
    public ddwWdith = '240px';
    public ddwWdithContact = '300px';
    public msDdwHeight = '100px';

    ngOnInit(): void {

        this.companyForm = this.fb.group({
            companyName: ['', { validators: [Validators.required], updateOn: 'blur' }],
            duns: ['', { validators: [Validators.required, Validators.pattern(/^[0-9]*$/), Validators.minLength(9), Validators.maxLength(9)], updateOn: 'blur' }],
            fei: ['', { validators: [Validators.pattern(/^(?=(?:.{7}|.{10})$)[0-9]*$/)], updateOn: 'blur' }],
            address: ['', { updateOn: 'blur' }],
            city: ['', { updateOn: 'blur' }],
            countryId: ['', { updateOn: 'blur' }],
            countryRegion: ['', { updateOn: 'blur' }],
            zip: ['', { updateOn: 'blur' }],
            contact_Est: ['', { updateOn: 'blur' }],
            contact_3rdParty_Est: ['', { updateOn: 'blur' }],
            contact_Labeler: ['', { updateOn: 'blur' }],
            contact_Importer: ['', { updateOn: 'blur' }],
            contact_Registrant: ['', { updateOn: 'blur' }],
            contact_usAgent: ['', { updateOn: 'blur' }],
            contact_allCompanyTypes: ['', { updateOn: 'blur' }],
            status: ['Active', { validators: [Validators.required], updateOn: 'blur' }],
            businessCategoryId: ['', { updateOn: 'blur' }],
            ndcLabelerCodes: this.fb.array([this.addLabelerFormGroup()]),
            businessOperationsForm: this.fb.array([this.createItem(true)]),
            allCompanyTypes: [''],
            isLabeler: [''],
            isRegistrant: [''],
            isUSAgent: [''],
            isImporter: [''],
            isThirdPartyEstablishment: [''],
            isEstablishmentOwner: ['']
        }, { validator: selectCompanyTypeValidator('isEstablishmentOwner', 'isThirdPartyEstablishment', 'isLabeler', 'isRegistrant', 'isUSAgent', 'isImporter') });

        this.companyRevisionId = this.activatedRoute.snapshot.params.companyRevisionId;
        this.companyData = this.activatedRoute.snapshot.data['companyData'];
        sessionStorage['tab'] = 'company';
        sessionStorage['fromCompanyPage'] = false;
        this.errorMessage = '';
        this.contactValidationTitleMsg = '';
        this.initialPage = { currentPage: 1, pageSize: 25, pageSizes: [25, 50, 75, 100, 'All'] };
        this.clearEditFlags();
        this.utilService.toggleClientDropdownState(true);

        // Get data from the resolver and populate various dropdownlists

        if (this.parentComponentInput && (this.parentComponentInput instanceof LCRFormComponent || this.parentComponentInput instanceof ERFormComponent || this.parentComponentInput instanceof LLFormEstablishmentComponent || this.parentComponentInput instanceof LLFormLabelerComponent || this.parentComponentInput instanceof LLFormRegistrantComponent)) {

            const type = this.parentComponentInput instanceof ERFormComponent ? 'Labeler' : 'Establishment_Owned';

            this.selectCompanyTypeFromModal(type);
        } else {

            this.populateDataFromResolver();
        }

        this.setButtons();

        // check for user access priviledge
        this.checkUserPermission();

        // set focus on the invisible div so the first tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
        this.initTabIndex();
    }

    initTabIndex() {
      (document.activeElement as HTMLElement).blur();

      const main = document.getElementById("firstDiv");

      if (main) {
        main.focus();
      }
    }

    setButtons() {
        // For new company
        if (!this.companyRevisionId) {
            this.buttonText = 'Create company';
            this.pageTitle = 'Create company';
            // Set company status default to "Active"
            this.getFormControlByName('status').patchValue('Active');
            this.version = '';
            this.formStatus = '';
            this.selectedBusinessCategoryId = '';
            this.selectedCountryId = '';
            this.selectedRegionId = '';
        } else {  // Modify existing company
            this.buttonText = 'Update company';
            this.pageTitle = 'Update company';
        }

        this.cdRef.detectChanges();
    }


    // Get data from the resolver and populate various dropdownlists
    populateDataFromResolver() {
        if (this.companyData.error) {
            this.toastr.error(this.companyData.error);
        } else {
            if (this.companyData) {
                if (this.companyData[0]) { // Business category
                    this.businessCategories = this.companyData[0];
                }
                if (this.companyData[1]) { // countries
                    this.countries = this.companyData[1]['countryList'];
                }
                if (this.companyData[2]) { // list of contacts
                    this.contacts = this.companyData[2]['latestAvailableContactsList'];
                }
                if (this.companyData[3]) { // business operation qualifiers
                    // Cache business operation qualifier info
                    this.storageManagerService.write('businessOperationQualifiers', this.companyData[3]);
                    this.businessOperationsTermList = this.refDataService.GetBusinessOperationsList();
                }

                if (this.companyData[5]) { // Previously saved business operation qualifiers
                    this.businessOperationArray = this.companyData[5];
                }
                if (this.companyData[6]) { // company detail
                    this.company = this.companyData[6]['companyDetails'];
                    this.bIsDraftMode = this.company.isDraftMode;
                    this.companyAssociations = this.companyData[6]['associatedContacts'];
                    this.companyId = this.company.companyId;
                    this.displayCompany(this.company);
                    this.selectedCountryId = +this.company.countryId === 0 || this.company.countryId === null || this.company.countryId === undefined ? '' : this.company.countryId;
                    this.bIsInternationalCompany = this.isInternationalCompany(+this.selectedCountryId);
                    this.selectedBusinessCategoryId = this.company.businessCategory && this.company.businessCategory.categoryId ? this.company.businessCategory.categoryId : null;
                    this.getFormControlByName('countryId').patchValue(this.selectedCountryId);
                    // this.getFormControlByName('businessCategoryId').patchValue(+this.selectedBusinessCategoryId);
                    this.companyForm.patchValue({
                        businessCategoryId: this.selectedBusinessCategoryId
                    });

                    this.selectedRegionId = this.company.countryRegion;
                    this.regionFromDrp = this.company.countryRegion;

                    this.version = this.company.version;
                    this.formStatus = 'Form Status: ' + this.company.formActiveFlag;

                    this.companyForm.patchValue({
                        countryRegion: this.company.countryRegion
                    });

                    this.regions = [];
                    if (this.selectedCountryId) {
                        this.regions$ = this.getRegionsByCountry(this.selectedCountryId);

                        this.sub = this.regions$.subscribe(data => {
                            this.regions = data;
                        });
                    }

                    if (this.companyData[7]) { // Previously saved business operation qualifiers
                        this.labelers = this.companyData[7];
                        // Populate Labeler forms

                        this.companyForm.setControl(
                            'ndcLabelerCodes',
                            this.setLabelerForm(this.labelers)
                        );
                    }
                } else {
                    this.regions = [];
                }

                if (this.companyData[4]) { // company historical data
                    this.companyHistory_grid_data = this.companyData[4];
                    // Check if a draft version exists if this is a major version
                    if (!this.company.isDraftMode && this.companyHistory_grid_data) {
                        const draftData = this.companyHistory_grid_data.filter(p => p.isDraftMode === true);
                        if (draftData && draftData.length > 0) {
                            this.toastr.warning('A draft version of this form already exists. It is recommended you complete the current draft version before creating a new draft otherwise those changes will be lost.');
                        }
                    }
                }
            }
            this.companyForm.markAsPristine();
        }
    }

    // Check if user has write permission. If no, disable the "Update Contact" button
    checkUserPermission() {
        if (this.authorizationService.hasPermission('SSDP.CanWriteCompany')) {
            this.bHasPermission = true;
        }
        if (this.authorizationService.hasPermission('SSDP.CanDeleteCompany')) {
            this.bHasDeletePermission = true;
        }
    }

    // Check if the company is an international company
    isInternationalCompany(countryID: number) {
        let bRet = false;
        if (countryID !== +this.COUNTRY_USA) {
            bRet = true;
        }

        return bRet;
    }

  ngAfterViewInit() {

    this.initBusinessOperationQualifier();

    if (this.countryRegionDdw) {
        this.countryRegionDdw.value = this.selectedRegionId;
    }

    this.companyForm.patchValue({

        countryRegion: this.selectedRegionId
    });

    this.cdRef.detectChanges();
}

    getCompanyId() {
        this.companyRevisionId = this.activatedRoute.snapshot.params.companyRevisionId;
    }

    // Retrieve a list of available contacts
    getContactList(): void {

        this.sub = this.companyService.getContacts().subscribe(data => {
            if (data) {
                this.contacts = data['latestAvailableContactsList'];
                // pre-select from the contact dropdown
                const currentContact = data['latestAvailableContactsList'].filter(x => x.contactId === +sessionStorage['ValidatedContactId']);
                if (currentContact && currentContact[0]) {
                    const selectedContact = this.getFormControlByName(sessionStorage['selectedContact_dropdownCtrlName']);
                    if (selectedContact) {
                        selectedContact.patchValue(currentContact[0].contactRevisionId);
                        this.contactRevisionId = currentContact[0].contactRevisionId;
                        this.cdRef.detectChanges();
                    }
                }
            }
        },
          error => {
            this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
          }
        );
    }

    // Get detail information for a specific contact
    getContactById(): void {
        this.sub = this.companyService.getContactById(this.contactRevisionId).subscribe(data => {
            if (data) {
                this.contactData = data['contactDetail'];
            }
        },
          error => {
            this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
          }
        );
    }

    // Retrieve a list of Regions/States based on the country selected by the user
    getRegionsByCountry(countryCode: string): Observable<IEntity> {

        this.regions$ = this.companyService.getRegionsByCountry(countryCode);

        return this.regions$;
    }

    // Retrieve historical company records
    getCompanyRevisionHistory(): void {
        this.sub = this.companyService.getCompanyRevisionHistory(Number(this.companyRevisionId)).subscribe(data => {
            if (data) {
                this.companyHistory_grid_data = data;
            }
        },
          error => {
            this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
          }
        );
    }

    // if the region code is not valid, set to empty
    validateRegion(regionCode: string) {
        if (this.regions) {
            const match = this.regions.filter(x => x.regionAndAbbreviation === regionCode);
            return match.length > 0 ? regionCode : '';
        } else {
            return '';
        }
    }

    // Format "Version" column on company history grid
    customizeCell(args: QueryCellInfoEventArgs) {
        if (args.column.field === 'version') {
            if (args.data['activeFlagFormatted'] === 'Active') {
                args.cell.innerHTML = args.data['version'] + '&nbsp;<span class="badge badge-success">current</span>';
            }
        }
    }

    // Get the state/regions for the country selected
    countrySelectionChanged(event) {

        if (event.itemData) {

            this.regions$ = this.getRegionsByCountry(event.itemData.id);
            this.bIsInternationalCompany = this.isInternationalCompany(event.itemData.id);
            this.sub = this.regions$.subscribe(data => {

                this.regions = data;
                this.cdRef.detectChanges();
            });
        } else {// selection being removed

            this.regionFromDrp = '';
            this.selectedRegionId = '';
            this.companyForm.controls['countryRegion'].patchValue('');

            this.countryRegionDdw.dataSource = [];
            this.countryRegionDdw.dataBind();
            this.countryRegionDdw.refresh();
            this.countryRegionDdw.value = null;
            this.bIsInternationalCompany = false;

            this.cdRef.detectChanges();
      }
    }

    stateSelectionChanged(event) {
        this.regionFromDrp = '';
        if (event.itemData) {
            this.regionFromDrp = event.itemData.regionAndAbbreviation;

            this.companyForm.controls['countryRegion'].patchValue(event.itemData.regionAndAbbreviation);
        } else {

            this.regionFromDrp = '';
            this.selectedRegionId = '';
            this.companyForm.controls['countryRegion'].patchValue('');

            this.countryRegionDdw.value = null;
        }

        this.cdRef.detectChanges();
    }

    // when user selecting contact to be associated with certain type of companu
    contactDrpSelectionChanged(event, type) {
        const associatedContact = new IContactCompany();
        associatedContact.associationType = type;
        associatedContact.associationActiveFlag = true;

        // Get the company Type for this contactf
        this.companyType = type;
        if (event.itemData) {
            // Get Contact Id
            this.contactRevisionId = event.itemData.contactRevisionId;
            this.contactId = event.itemData.contactId;
            associatedContact.contactRevisionId = this.contactRevisionId;

            // Call API to validate if the selected contact has sufficient data for the company type it is being assigned to
            // if contact being selected does not have required data for the company type, allow user to enter contact info
            const currentCompanyTypeInfo = this.companyTypes.filter(x => x.type === type)[0];
            sessionStorage['selectedContact_dropdownCtrlName'] = currentCompanyTypeInfo.dropdownCtrlName;
            if (sessionStorage['ValidatedContactSave'] === 'null' || sessionStorage['ValidatedContactSave'] === undefined) {
                this.ValidateContactAssociation(associatedContact);
            } else {
                sessionStorage['ValidatedContactSave'] = null;
            }
            // Show Contact Detail link ( don't show if Company is opened in the modal)
            if (!this.parentComponentInput) {
                this.showEditLinkFlags(type);
            }

        } else { // remove selection
            // hide contact detail link
            this.hideEditLinkFlags(type);
        }
    }

    // Validate if a contact has required information for a specific type of company
    ValidateContactAssociation(contact: IContactCompany): void {
        this.sub = this.companyService.ValidateContactAssociation(contact).subscribe(data => {
            if (data) {
                if (!data.isValid) {
                    this.contactValidationTitleMsg = data.errorMessage;
                    sessionStorage['ValidatedContactId'] = this.contactId;
                    sessionStorage['ValidatedContactSave'] = null;
                    this.dialogConfirmation.show();
                }
            }
        },
            error => {
              this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
            }
        );
    }

    // Save/Update company info
    saveCompany(formValues): void {
        this.submitted = true;
        this.errorMessage = '';
        this.bValidationErrorExist = false;

        if (this.companyForm.valid) {
            this.companyForm.markAsPristine();
            this.prepareDataForSave(formValues);

            const uniqueLabelers = this.removeDuplicatesLabelersFromArray(formValues.ndcLabelerCodes);

            const companyForCreation: ICompany = {
                companyDetails: formValues,
                CompanyContactAssociation: this.getSelectedContactsForSave(),
                businessOperQualifier: this.getSelectedBusinessOperQualifiersForSave(),
                ndcLabelerCodes: uniqueLabelers
            };

            this.sub = this.companyService.createCompany(companyForCreation).subscribe(data => {
                // Check for Busness Operations validate errors
                if (data && data.isValid === false) {
                    this.splValidationMessages = data['validationMessages'];
                    this.bValidationErrorExist = true;
                    this.cdRef.detectChanges();
                } else {

                    if (!this.parentComponentInput) {
                        if (!this.bIsDraftMode) {
                            this.router.navigate(['/company-dashboard']);
                            return data;
                        } else {
                            // Force angular to rerun ngOnInit to reload data when navigating to address
                            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                            this.router.onSameUrlNavigation = 'reload';
                            this.router.navigate(['/company-details', data.companyRevId]);
                        }
                    } else {

                        if (this.parentComponentInput && (this.parentComponentInput instanceof LCRFormComponent || this.parentComponentInput instanceof ERFormComponent || this.parentComponentInput instanceof LLFormLabelerComponent
                            || this.parentComponentInput instanceof LLFormRegistrantComponent || this.parentComponentInput instanceof LLFormEstablishmentComponent)) {
                            this.companyForm.reset();
                            this.companyOutput.emit(data);
                        }
                    }
                }
            },
                error => {
                  // this.errorMessage = error && error['data'] ? error['data'].toString() : (error ? error.message : 'Internal Error!');
                  // this.toastr.error(this.errorMessage);
                  this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
                }
            );
        }
    }

    // Formate Business Operations validation errors
    customizeErrorCell(args: QueryCellInfoEventArgs) {

        if (args.data['messageType'] === 'Error') {
            args.cell.classList.add('customcssError');
        } else if (args.data['messageType'] === 'Warning') {
            args.cell.classList.add('customcssWarning');
        }
    }

    removeDuplicatesLabelersFromArray(formArray): INdcLabeler[] {

        const uniqueArray = formArray
            .map(item => item.ndcLabelerCode)
            .filter((value, index, self) => self.indexOf(value) === index);

        const uniqueFormArray: INdcLabeler[] = [];

        uniqueArray.forEach(code => {

            const labeler = new INdcLabeler();
            labeler.ndcLabelerCode = code;

            uniqueFormArray.push(labeler);
        });

        return uniqueFormArray;
    }

    // Check if the current company is either establishment owned or establishment 3rd party
    isEstablishment(): boolean {
        this.isEstablishmentChecked = this.getFormControlByName('isEstablishmentOwner').value;
        this.is3rdPartyEstablishmentChecked = this.getFormControlByName('isThirdPartyEstablishment').value;
        if (this.isEstablishmentChecked || this.is3rdPartyEstablishmentChecked) {
            return true;
        } else {
            return false;
        }
    }

    // Get user selected contacts for various company types and generate a list for save
    getSelectedContactsForSave(): IContactForSave[] {
        this.lstCompanyAssociations = [];
        this.companyTypeCtrlNames.forEach((ckName) => {
            const currentCompanyTypeInfo = this.companyTypes.filter(x => x.ckName === ckName)[0];
            const ctrlCheckbox = <CheckBox><unknown><UntypedFormControl>this.getFormControlByName(ckName);
            const ctrlContactDrp = this.getFormControlByName(currentCompanyTypeInfo.dropdownCtrlName);
            if (ctrlCheckbox != null && ctrlCheckbox.value) {
                // Check if user has selected any contact
                if (ctrlContactDrp.value) {
                    const contact: IContactForSave = {
                        companyContactRoleCode: currentCompanyTypeInfo.type,
                        contactRevisionId: ctrlContactDrp.value,
                        associationActiveFlag: true
                    };
                    this.lstCompanyAssociations.push(contact);
                }
            }
        });

        return this.lstCompanyAssociations;
    }

    // Get user selected business operation qualifiers and generate a list for save
    getSelectedBusinessOperQualifiersForSave(): IBusinessOperationQualifierList {
        this.lstBusiOperQualifiers = [];

        // only do this for est owned and estab. third party
        if (this.isEstablishment()) {
            this.businessOperationsForms.value.forEach((bo) => {
                // skip when no business operation is being select
                if (bo.businessOperations && bo.businessOperations.length > 0) {
                    // if no business operation qualifier exists for this business operation, add an entry to the list
                    if (bo.businessOperationsQualifiers && bo.businessOperationsQualifiers.length === 0) {
                        const qualifier = new IBusinessOperationQualifier();
                        qualifier.parentTermValueCode = bo.businessOperations;
                        qualifier.parentTermValueName = this.refDataService.GetBussinesOperationDescByCode(bo.businessOperations);
                        this.lstBusiOperQualifiers.push(qualifier);
                    } else {
                        // Loop through a list of qualifiers for this business operation
                        if (bo.businessOperationsQualifiers) {
                            bo.businessOperationsQualifiers.forEach((boq) => {
                                const qualifier = new IBusinessOperationQualifier();
                                qualifier.parentTermValueCode = bo.businessOperations;
                                qualifier.parentTermValueName = this.refDataService.GetBussinesOperationDescByCode(bo.businessOperations);
                                qualifier.childTermValueCode = boq;
                                qualifier.childTermValueName = this.refDataService.GetBussinesOperationQualifierDescByCode(bo.businessOperations, boq);
                                // avoid duplicates
                                if (!this.checkForDuplicate(this.lstBusiOperQualifiers, bo.businessOperations, boq)) {
                                    this.lstBusiOperQualifiers.push(qualifier);
                                }
                                // }
                            });
                        }
                    }
                }
            });
        }
        const IBusiOperQuals: IBusinessOperationQualifierList = {
            businessOperationBusinessOperationQualifierList: this.lstBusiOperQualifiers
        };
        return IBusiOperQuals;
    }

    // Check if this qualifier already exixt
    checkForDuplicate(qualifier: IBusinessOperationQualifier[], busOperCode: string, qualCode: string): boolean {
        const boq = qualifier.filter(x => x.parentTermValueCode === busOperCode && x.childTermValueCode === qualCode);
        const bFound = boq.length === 0 ? false : true;
        return bFound;
    }


    // Populate the company form
    displayCompany(company: ICompanyDetail) {
        this.companyForm.patchValue({
            companyName: company.companyName,
            duns: company.duns,
            fei: company.fei,
            address: company.address,
            city: company.city,
            zip: company.zip,
            isEstablishmentOwner: company.establishmentOwner === 'Y' ? true : false,
            isThirdPartyEstablishment: company.thirdPartyEstablishment === 'Y' ? true : false,
            isLabeler: company.labeler === 'Y' ? true : false,
            isRegistrant: company.registrant === 'Y' ? true : false,
            isImporter: company.importer === 'Y' ? true : false,
            isUSAgent: company.usAgent === 'Y' ? true : false
        });

        // Check if "Company Type" checkbox has been selected, if yes, enable the "Update Company" button, otherwise, disable it
        this.setUpdateCompanyButtonStatus();

        // Preselect company type checkboxes and pre-populate company contacts
        if (this.companyAssociations != null && this.companyAssociations.length > 0) {
            this.companyAssociations.forEach((element) => {
                // Find this element by type from the companyTypes array
                const currentCompanyTypeInfo = this.companyTypes.filter(x => x.type === element.contactType)[0];
                const ctrlContactDrp = this.getFormControlByName(currentCompanyTypeInfo.dropdownCtrlName);
                ctrlContactDrp.patchValue(element.contactRevisionId);
                // Show Contact Detail link
                this.contactRevisionId = element.contactRevisionId;

                // don't need to display "Edit info" on the modal
                if (!this.parentComponentInput) {
                    this.showEditLinkFlags(element.contactType);
                }

                // Perform a check to see if the associated contact is no longer the latest (if it is not the latest it will not be pre-selected since it is not present in the LatestContacts list)
                if (!this.IsAssociatedContactLatest(element)) {
                    switch (element.contactType) {
                        case 'Establishment_Owned':
                            this.nonLatestCompanyContact.EstablishmentContactOwned = element.contactName;
                            this.showEditLink_Est = false;
                            break;
                        case 'Establishment_Third_Party':
                            this.nonLatestCompanyContact.EstablishmentThirdPartyContact = element.contactName;
                            this.showEditLink_3rdParty_Est = false;
                            break;
                        case 'Importer':
                            this.nonLatestCompanyContact.ImporterContact = element.contactName;
                            this.showEditLink_Importer = false;
                            break;
                        case 'Labeler':
                            this.nonLatestCompanyContact.LabelerContact = element.contactName;
                            this.showEditLink_Labeler = false;
                            break;
                        case 'Registrant':
                            this.nonLatestCompanyContact.RegistrantContact = element.contactName;
                            this.showEditLink_Registrant = false;
                            break;
                        case 'US_Agent':
                            this.nonLatestCompanyContact.USAgentContact = element.contactName;
                            this.showEditLink_USAgent = false;
                            break;
                        default:
                    }
                }
            });
        }

        // Populate business operations if applicable
        this.companyForm.setControl(
            'businessOperationsForm',
            this.setBusinessOperationForm(this.businessOperationArray)
        );
    }

    // Check if "Company Type" checkbox has been selected, if yes, enable the "Update Company" button, otherwise, disable it
    setUpdateCompanyButtonStatus() {
        this.disableUpdateCompanyButton = true;
        for (let i = 0; i < this.companyTypes.length; i++) {
            if (this.getFormControlByName(this.companyTypes[i].ckName).value === true) {
                this.disableUpdateCompanyButton = false;
                break;
            }
        }
    }

    IsAssociatedContactLatest(contact: IContactCompany): Boolean {
        // Check to see if the associated contact is the latest. If so, it will be apart of the CompanyData latestAvailableContactsList property(position 2 in the companyData array)
        let isFound = false;
        this.companyData[2].latestAvailableContactsList.forEach((availableContact) => {
            if (contact.contactRevisionId === availableContact.contactRevisionId) {
                isFound = true;
            }
        });
        return isFound;
    }

    // pre-select the business operations and business operations qualifiers dropdowns
    setBusinessOperationForm(businessOperationsArray: IBusinessOperationQualifier[]): UntypedFormArray {
        const formArray = new UntypedFormArray([]);

        if (businessOperationsArray && businessOperationsArray.length > 0) {
            businessOperationsArray.forEach((c, i) => {
                const busOperQual = c.childTermValueCode != null ? c.childTermValueCode.replace(' ', '').split(',') : [];
                formArray.push(
                    this.fb.group({
                        businessOperations: c.parentTermValueCode,
                        businessOperationsQualifiers: this.fb.array(busOperQual)
                    })
                );
                this.businessOperationsQualifierList[i] = this.refDataService.GetQualifierByBusOper(c.parentTermValueCode);
            });
        } else {
            formArray.push(
                this.fb.group({
                    businessOperations: ['', Validators.required],
                    businessOperationsQualifiers: this.fb.array([''])
                })
            );
        }

        return formArray;
    }

    // Get the object ready before being saved
    prepareDataForSave(formValues) {
        const sessionCurrentCustomer = this.storageManagerService.read('currentCustomer');
        const currentCustomer = typeof sessionCurrentCustomer === 'object' ? sessionCurrentCustomer : JSON.parse(sessionCurrentCustomer);
        const authData = this.authService.getAuthData();

        formValues['isDraftMode'] = this.bIsDraftMode;
        formValues['FormActiveFlag'] = 'A';
        formValues['modifiedBy'] = authData.name;
        // formValues['businessCategoryId'] = this.f.businessCategoryId.value === '' ? this.selectedBusinessCategoryId : this.f.businessCategoryId.value;
        // formValues['businessCategory'] = formValues['businessCategoryId'];
        formValues['businessCategory'] = this.getGenericKeyObjectForBC(this.businessCategories, this.f.businessCategoryId.value === '' ? this.selectedBusinessCategoryId : this.f.businessCategoryId.value);
        formValues['countryRegion'] = this.f.countryRegion.value === '' ? this.selectedRegionId : this.f.countryRegion.value;
        formValues['countryRegion'] = this.validateRegion(formValues['countryRegion']);
        formValues['countryId'] = this.f.countryId.value === '' ? this.selectedCountryId : this.f.countryId.value;
        formValues['country'] = formValues['countryId'];
        formValues['UserId'] = currentCustomer.customerGuid;
        formValues['isRegistrantConfidentiality'] = 'N';
        formValues['isEstablishmentConfidentality'] = 'N';
        formValues['isImporter'] = formValues['isImporter'] === true || formValues['isImporter'] === 'Y' ? 'Y' : 'N';
        formValues['isLabeler'] = formValues['isLabeler'] === true || formValues['isLabeler'] === 'Y' ? 'Y' : 'N';
        formValues['isRegistrant'] = formValues['isRegistrant'] === true || formValues['isRegistrant'] === 'Y' ? 'Y' : 'N';
        formValues['isUSAgent'] = formValues['isUSAgent'] === true || formValues['isUSAgent'] === 'Y' ? 'Y' : 'N';
        formValues['isEstablishmentOwner'] = formValues['isEstablishmentOwner'] === true || formValues['isEstablishmentOwner'] === 'Y' ? 'Y' : 'N';
        formValues['isThirdPartyEstablishment'] = formValues['isThirdPartyEstablishment'] === true || formValues['isThirdPartyEstablishment'] === 'Y' ? 'Y' : 'N';

        // if we are creating a new company, we need to clear out the companyId
        if (this.companyRevisionId) {
            formValues['companyRevisionId'] = this.companyRevisionId;
            formValues['companyId'] = this.companyId;
            formValues['parentVersion'] = this.company.parentVersion;

            // Determine what to use for parentVersion
            formValues['parentVersion'] = this.company.version;
        } else {
            formValues['companyRevisionId'] = null;
            sessionStorage['currentCompanyId'] = null;
            sessionStorage['currentCompanyRevisionId'] = null;
            formValues['parentVersion'] = '0.0';
        }
    }

    // Build an ILLBusinessCategory object for Business Category
    getGenericKeyObjectForBC(list: any[], id: any): ILLBusinessCategory {
        const retVal = new ILLBusinessCategory();

        if (list && id) {
            list = list.filter(x => x['categoryId'] === id);
            if (list && list.length > 0) {
                retVal.categoryId = id && id !== '0' ? id : '';
                retVal.label = list[0]['label'];
            }
        }
        return retVal;
    }

    // Display confirmation message
    showMessage() {
        sessionStorage['currentContactId'] = this.contactId;
        this.dialogConfirmation.hide();
        this.ejDialog.show();
    }

    editContactInfo(event) {
        if (event.itemData) {
            this.contactRevisionId = event.itemData.contactRevisionId;
            sessionStorage['fromCompanyPage'] = true;
            sessionStorage['currentContactId'] = event.itemData.contactId;
            sessionStorage['ValidatedContactId'] = event.itemData.contactId;
            sessionStorage['currentContactRevisionId'] = event.itemData.contactRevisionId;
            this.getContactById();
            this.contact.clearForm();
            this.ejDialog.show();
        }
    }

    closeConfirmDialog() {
        this.dialogConfirmation.hide();
    }

    // reset the contact dropdown selection
    selectCompanyType(event: any): void {
        const type = event.target.value;
        const currentCompanyTypeInfo = this.companyTypes.filter(x => x.type === type)[0];
        const ctrlContactDrp = this.getFormControlByName(currentCompanyTypeInfo.dropdownCtrlName);
        ctrlContactDrp.patchValue(null);

        if (this.isEstablishment()) {
            this.changeFormArrayControlStatus(true);

        } else {
            this.changeFormArrayControlStatus(false);
            this.clearBusOpAndQualifiers();
        }
        this.setUpdateCompanyButtonStatus();
    }

    // Clear out Business Operations & qualifiers section
    clearBusOpAndQualifiers() {

        for (let i = this.businessOperationsForms.controls.length - 1; i > 0; i--) {
            this.businessOperationsForms.removeAt(i);
        }
        if (this.businessOperationsForms.controls && this.businessOperationsForms.controls.length > 0) {
            const busOp = this.businessOperationsForms.controls[0].get('businessOperations');
            busOp.setValue('');
            busOp.setValidators([Validators.required]);
            busOp.updateValueAndValidity();
        }

        this.bValidationErrorExist = false;
    }

    // Clear out user's previous Business Operation selection
    setEmptyBusOpForm() {
        const formArray = new UntypedFormArray([]);
        formArray.push(
            this.fb.group({
                businessOperations: [''],
                businessOperationsQualifiers: this.fb.array([''])
            })
        );
        return formArray;
    }

    // Make sure Business Operations dropdown is required
    setBusOpFormRequired() {
        const formArray = new UntypedFormArray([]);
        formArray.push(
            this.fb.group({
                businessOperations: ['', Validators.required],
                businessOperationsQualifiers: this.fb.array([''])
            })
        );
        return formArray;
    }

    selectCompanyTypeFromModal(type): void {

        const currentCompanyTypeInfo = this.companyTypes.filter(x => x.type === type)[0];
        const ctrlContactDrp = this.getFormControlByName(currentCompanyTypeInfo.dropdownCtrlName);
        ctrlContactDrp.patchValue(null);

        if (type === 'Labeler') {
            this.changeFormArrayControlStatus(false);
        } else {
            this.changeFormArrayControlStatus(true);
        }
    }

    // Enable/Disable all the controls on the FormArray
    changeFormArrayControlStatus(status: boolean) {
        this.businessOperationsForms.controls.forEach((ctrl) => {
            if (status) {
                ctrl.enable();
            } else {
                ctrl.disable();
            }
        });
    }

    selectAllCompanyTypes(event: any): void {
    }

    // Get a form control by name
    getFormControlByName(controlName: string): UntypedFormControl {
        return <UntypedFormControl>this.companyForm.get(controlName);
    }

    // convenience getter for easy access to form fields
    get f() { return this.companyForm.controls; }

    // when cancel button is being clicked
    cancelBtnClicked() {

        if (!this.parentComponentInput) {

            this.router.navigateByUrl('/company-dashboard');
        } else {
            this.companyForm.clearValidators();
            this.companyForm.reset();
            this.cancelButtonClickedOutput.emit();
        }
    }

    // This is a known bug by syncFusion where a popup will open by default, the following is the suggested workaround
    onCreated() {
        this.ejDialog.hide();
    }

    closeDialog() {
        // If user updated contact info, then we need to reload the contact list with the newly saved contact info
        if (sessionStorage['ValidatedContactSave'] === 'true') {
            this.getContactList();
        }

        this.ejDialog.hide();
    }

    ngOnDestroy(): void {
        if (this.sub) {
            this.sub.unsubscribe();
        }
        this.utilService.toggleClientDropdownState(false);
    }

    get businessOperationsForms(): UntypedFormArray {
        return <UntypedFormArray>this.companyForm.get('businessOperationsForm');
    }

    initBusinessOperationQualifier() {
        this.msArray = this.boq_mdrp.toArray();
        if (this.businessOperationArray && this.businessOperationArray.length > 0) {
            this.businessOperationArray.forEach((bo, i) => {
                if (this && this.msArray[i] && this.msArray[i] !== undefined) {
                    const busQ = bo.childTermValueCode.replace(' ', '');
                    if (busQ) {
                        this.msArray[i].value = bo.childTermValueCode != null ? busQ.split(',') : [];
                    }
                }
            });
        }

        // Disable business operation dropdowns
        if (!this.isEstablishment()) {
            this.changeFormArrayControlStatus(false);
        }
    }

    // Get the business operations qualifiers based on the business operation being selected
    boSelectionChanged(event, i) {
        this.companyForm.markAsDirty();
        this.companyForm.markAsTouched();

        if (event.itemData) {
            this.businessOperationsQualifierList[i] = this.refDataService.GetQualifierByBusOper(event.itemData.parentTermValueCode);
            // clear out the previous selected qualifiers
            this.msArray = this.boq_mdrp.toArray();
            this.msArray[i].value = [];
        } else {// selection being removed
            this.businessOperationsQualifierList[i] = [];
        }
    }

    // Change event for business operations qualifiers
    boqSelectionChanged(event, i) {
        this.businessOperationsForms.value[i].businessOperationsQualifiers = event.value;
    }

    boQualifierSelectionChanged(event) {
        this.companyForm.markAsDirty();
        this.companyForm.markAsTouched();
    }

    /**
      * Watches selection of multiselect dropdown chip selected
      * @param  {} e - element
      * @param  {} i - index
      */
    chipSelected(e, i) {
        this.companyForm.markAsDirty();
        this.companyForm.markAsTouched();

        if (e.itemData !== undefined) {
            if (this.businessOperationsForms.value[i].businessOperationsQualifiers.length > 0 && this.businessOperationsForms.value[i].businessOperationsQualifiers[0] === '') {
                this.businessOperationsForms.value[i].businessOperationsQualifiers.splice(0, 1);
            }
            this.businessOperationsForms.value[i].businessOperationsQualifiers.push(e.itemData.childTermValueCode);
        }
    }

    /**
     * Watches selection of multiselect dropdown chip removed
     * @param  {} e - element
     * @param  {} i - index
     */
    chipRemoved(e, i) {
        this.businessOperationsForms.value[i].businessOperationsQualifiers.splice(i, 1);
        this.companyForm.markAsDirty();
        this.companyForm.markAsTouched();
    }

    createItem(bRequired: boolean): UntypedFormGroup {
        if (bRequired) {
            return this.fb.group({
                businessOperations: ['', Validators.required],
                businessOperationsQualifiers: this.fb.array([''])
            });
        } else {
            return this.fb.group({
                businessOperations: [''],
                businessOperationsQualifiers: this.fb.array([''])
            });
        }

    }

    addItem(): void {
        this.businessOperationsForms.push(this.createItem(this.businessOperationsForms.length === 0));
        this.businessOperationsForms.markAsDirty();
        this.businessOperationsForms.markAsTouched();
    }

    removeItem(i) {
        this.businessOperationsForms.removeAt(i);
        this.businessOperationsQualifierList.splice(i, 1);
        if (this.businessOperationsForms.length === 1) {
            this.changeFormArrayControlStatus(true);
        }
        this.companyForm.markAsDirty();
        this.companyForm.markAsTouched();
    }

    // Display detail of a single company
    viewCompany(companyRevisionId: string, companyId: string) {
        if (companyRevisionId) {
            sessionStorage['currentCompanyRevisionId'] = companyRevisionId;
            // sessionStorage['currentCompanyId'] = companyId;

            // reload with new data
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
                this.router.navigate(['/company-details', companyRevisionId]));
        }
    }

    setEditLinkFlags(type: string, flag: boolean) {
        this.clearEditFlags();
        switch (type) {
            case '3rdPartyEstablishment':
                this.showEditLink_3rdParty_Est = flag;
                break;
            case 'Establishment':
                this.showEditLink_Est = flag;
                break;
            case 'Importer':
                this.showEditLink_Importer = flag;
                break;
            case 'Labeler':
                this.showEditLink_Labeler = flag;
                break;
            case 'US_Agent':
                this.showEditLink_USAgent = flag;
                break;
            case 'Registrant':
                this.showEditLink_Registrant = flag;
                break;
        }
    }


    // Removve "Edit Contact Info" link for contact selected for associating to a company
    clearEditFlags() {
        this.showEditLink_Est = false;
        this.showEditLink_3rdParty_Est = false;
        this.showEditLink_Importer = false;
        this.showEditLink_Labeler = false;
        this.showEditLink_USAgent = false;
        this.showEditLink_Registrant = false;
    }

    // Display "Edit Contact Info" link for contact selected for associating to a company
    showEditLinkFlags(type: string) {
        switch (type) {
            case 'Establishment_Owned':
                this.showEditLink_Est = true;
                break;
            case 'Establishment_Third_Party':
                this.showEditLink_3rdParty_Est = true;
                break;
            case 'Importer':
                this.showEditLink_Importer = true;
                break;
            case 'Labeler':
                this.showEditLink_Labeler = true;
                break;
            case 'US_Agent':
                this.showEditLink_USAgent = true;
                break;
            case 'Registrant':
                this.showEditLink_Registrant = true;
                break;
        }
    }

    // Hide "Edit Contact Info" link for contact selected for associating to a company
    hideEditLinkFlags(type: string) {
        switch (type) {
            case 'Establishment':
                this.showEditLink_Est = false;
                break;
            case 'Importer':
                this.showEditLink_Importer = false;
                break;
            case 'Labeler':
                this.showEditLink_Labeler = false;
                break;
            case 'US_Agent':
                this.showEditLink_USAgent = false;
                break;
            case 'Registrant':
                this.showEditLink_Registrant = false;
                break;
        }
    }

    // set the form as draft mode
    setDraftMode(event) {
        this.bIsDraftMode = true;
        // event.target.disabled = true;
    }

    // set the form as active mode
    setActiveMode() {
        this.bIsDraftMode = false;
        window.scroll(0, document.body.scrollHeight);
    }

    addLabelerFormGroup(): UntypedFormGroup {
        return this.fb.group({
            ndcLabelerCode: ['', { updateOn: 'blur' }]
        });
    }

    get labelerFormsArray(): UntypedFormArray {
        return <UntypedFormArray>this.companyForm.get('ndcLabelerCodes');
    }

    addLabelerFormGroupButtonClick(): void {
        this.labelerFormsArray.push(this.addLabelerFormGroup());
        this.labelerFormsArray.markAsDirty();
        this.labelerFormsArray.markAsTouched();
    }

    removeLabelerFormGroupButtonClick(index: number): void {
        this.labelerFormsArray.removeAt(index);
        this.labelerFormsArray.markAsDirty();
        this.labelerFormsArray.markAsTouched();
    }

    isLabelerCodeDuplicate(): boolean {
        let isDuplicate: boolean;

        // Check length greater than 1 because if 1 cannot be duplicated
        if (
            this.labelerFormsArray &&
            this.labelerFormsArray.controls &&
            this.labelerFormsArray.controls.length > 1
        ) {
            const valueArr = this.labelerFormsArray.controls.map(function (item) {
                return item.value.labelerCode;
            });

            isDuplicate = valueArr.some(function (item, idx) {
                return valueArr.indexOf(item) !== idx;
            });
        }

        return isDuplicate;
    }

    setLabelerForm(labelerCodes: any[]): UntypedFormArray {
        const formArray = new UntypedFormArray([]);

        if (labelerCodes && labelerCodes.length > 0) {
            labelerCodes.forEach((c, i) => {
                formArray.push(
                    this.fb.group({
                        ndcLabelerCode: c.ndcLabelerCode
                    })
                );
            });
        } else {
            formArray.push(
                this.fb.group({
                    ndcLabelerCode: ''
                })
            );
        }

        return formArray;
    }

    ngAfterViewChecked() {
        this.cdRef.detectChanges();
  }

  tooltipValue(args) {

    let grid;
    let currentGridId;
    let tooltip: TooltipComponent;

    currentGridId = args.event.currentTarget.firstChild.id;

    if (args.target.scrollWidth <= args.target.clientWidth) {
      args.cancel = true;
    } else {

      if (currentGridId) {
        switch (currentGridId) {
          case 'companyHistoryGrid':
            grid = this.companyHistoryGrid;
            tooltip = this.tooltipCompanies;
            break;
          case 'errorGrid':
            grid = this.errorGrid;
            tooltip = this.tooltipError;
            break;
        }

        const rowInfo = grid.getRowInfo(args.target);
        const rowData = rowInfo.rowData;
        tooltip.cssClass = 'customTooltip';
        tooltip.content = rowData[(rowInfo.column as any).field];
      }
    }
  }


    /**
    * The function drills to down from the FormGroup or FormArray down
    * to the AbstractControl in order to check if the value is entered.
    * Populates the FormErrors object based on the Validators attached to the formControls.
    * @param {FormGroup} group passed by the form validation.
    */
    logValidationErrors(group: UntypedFormGroup = this.companyForm): void {
        Object.keys(group.controls).forEach((key: string) => {
            const abstractControl = group.get(key);

            this.formErrors[key] = '';
            if (
                abstractControl &&
                !abstractControl.valid &&
                (abstractControl.touched || abstractControl.dirty)
            ) {
                const messages = this.validationMessages[key];

                for (const errorKey in abstractControl.errors) {
                    if (errorKey) {
                        this.formErrors[key] += messages[errorKey] + ' ';
                    }
                }
            }

            if (abstractControl instanceof UntypedFormGroup) {
                this.logValidationErrors(abstractControl);
            }

            // We need this additional check to get to the FormGroup
            // in the FormArray and then recursively call this
            // logValidationErrors() method to fix the broken validation
            if (abstractControl instanceof UntypedFormArray) {
                for (const control of abstractControl.controls) {
                    if (control instanceof UntypedFormGroup) {
                        this.logValidationErrors(control);
                    }
                }
            }
        });
    }
}


